module.exports = __webpack_public_path__ + "img/david.fc3c3830.png";